import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'mobx-react'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import {GeneralStore} from './MobxStores/GeneralStore'
import {ProcedureStore} from './MobxStores/ProcedureStore'
import {ProjectStore} from './MobxStores/ProjectStore'
import {createBrowserHistory, createHashHistory} from 'history';
import {ModalStore} from "./MobxStores/ModalStore";
import {DragStore} from "./MobxStores/DragStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DataStore} from "./MobxStores/DataStore";
import 'bootstrap/dist/css/bootstrap.min.css';
import {DayadaStore} from "./MobxStores/DayadaStore";
import {RtcStore} from "./MobxStores/RtcStore";
import {EditorStore} from "./MobxStores/EditorStore";
import {SocketStore} from "./MobxStores/SocketStore";
import {TableStore} from "./MobxStores/TableStore";
import {SurveyStore} from "./MobxStores/SurveyStore";
import Settings from "./settings.json";
import { Buffer } from 'buffer';
import process from 'process';
import {WorkspaceManagementStore} from "./MobxStores/WorkspaceManagementStore";
import {AiStore} from "./MobxStores/AiStore";
import {AiStudioStore} from "./MobxStores/AiStudioStore";
import {GuidesUploadStore} from "./MobxStores/GuidesUploadStore";
import {IncomingCallStore} from "./MobxStores/IncomingCallStore";

window.Buffer = Buffer;
window.process = process;
const dataStore = new DataStore();
const modalStore = new ModalStore();
const generalStore = new GeneralStore();
const projectStore = new ProjectStore(dataStore, modalStore);
const procedureStore = new ProcedureStore(dataStore, projectStore);
const dragStore = new DragStore(dataStore);
const dayadaStore = new DayadaStore();
const editorStore = new EditorStore();
const socketStore = new SocketStore();
const tableStore = new TableStore(modalStore);
const surveyStore = new SurveyStore(modalStore, generalStore);
const rtcStore = new RtcStore(modalStore, surveyStore);
const guidesUploadStore = new GuidesUploadStore(modalStore, generalStore, projectStore);
const workspaceManagementStore = new WorkspaceManagementStore(generalStore, modalStore, tableStore);
const aiStore = new AiStore(modalStore, projectStore, procedureStore, generalStore, editorStore);
const aiStudioStore = new AiStudioStore(aiStore, generalStore, modalStore, projectStore)
const incomingCallStore = new IncomingCallStore();

export {generalStore, projectStore, procedureStore, dataStore, modalStore, editorStore, socketStore,surveyStore , tableStore, workspaceManagementStore, aiStore, guidesUploadStore, aiStudioStore, incomingCallStore};

const stores = {
    generalStore,
    procedureStore,
    projectStore,
    modalStore,
    dragStore,
    dataStore,
    dayadaStore,
    editorStore,
    rtcStore,
    socketStore,
    tableStore,
    surveyStore,
    workspaceManagementStore,
    aiStore,
    guidesUploadStore,
    aiStudioStore,
    incomingCallStore,
};     //create stores object of all Mobx stores

export const history = Settings.isNative ? createHashHistory() : createBrowserHistory();

localStorage.clear();

React.createContext({stores});

ReactDOM.render(
    //wrap App component in Provider component for general access to Mobx global state manager
    <Provider {...stores}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App history={history}/>
        </LocalizationProvider >
    </Provider>
    , document.getElementById('root'))


serviceWorker.unregister(); // TODO

console.log(
    '                                                            \n' +
    '                           *,,,,,,                          \n' +
    '                    ,,,,,,,,,,,,,,,,,,,,,                   \n' +
    '                ,,,,,,,,,,,,,,,,,,,,,,,,,,,,*               \n' +
    '              ,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,             \n' +
    '            ,,,,,,,,,*@@@@@@@@@@@@@@@@@@@@@@@@@@@           \n' +
    '          ,,,,,,,,,,,@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@         \n' +
    '         ,,,,,,,,,,,@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@        \n' +
    '        .,,,,,,,,,,,@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,,,        \n' +
    '        ,,,,,,,,,,,*@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,,,*       \n' +
    '        ,,,,,,,,,,,@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,,,,,       \n' +
    '        ,,,,,,,,,,,@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,,,,*       \n' +
    '        .,,,,,,,,,/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@*       \n' +
    '         *,,,,,,,,@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@        \n' +
    '          *,,,,,,,@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@         \n' +
    '            ,,,,,#@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,,           \n' +
    '              ,,,@@@@@@@@@,,,,,,,,,,,,,,,,,,,,,             \n' +
    '                *@@@@@@@@@,,,,,,,,,,,,,,,,,,*     .         \n' +
    '                    @@@@@&,,,,,,,,,,,,,,*       ,,,,,       \n' +
    '                                                            \n' +
    '\n' +
    '\n' +
    'Are you a keyboard warrior who thrives on code? Make it your daily quest!\n' +
    'We\'re on the lookout for wizards adept in the arcane arts of React, Node.js, and Unity.\n' +
    'Beam us your resume at jobs@frontline.io, and we\'ll connect with you faster than broadband.'
)

if (Settings.env !== 'dev') {
    console.log = () => {
    };
    console.warn = () => {
    };
    console.error = () => {
    };
    console.debug = () => {
    };
    console.info = () => {
    };
}